<template>
    <div>
        <AppTitle>
            <template #title>ตู้แช่ยาและเวชภัณฑ์</template>
            <template #subtitle> Wanon Niwat Hospital [5S SYSTEM WNH] </template>
            <template #breadcrumb>หน้าหลัก</template>
        </AppTitle>

        <div class="row">
            <div class="col-md-12">
                <div class="tile">

                    <!-- <div class="tile-title-w-btn">
                        <h3 class="title">ตู้แช่ยาและเวชภัณฑ์ ทั้งหมด</h3>
                        <p>
                            <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                <i class="bi bi-plus-square me-2"></i> Add Item
                            </a>
                        </p>
                    </div> -->
                    <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                        <h3 class="title">ตู้แช่ยาและเวชภัณฑ์ ทั้งหมด</h3>

                        <div class="d-flex align-items-center gap-2">
                            <select v-model="filterKey" class="form-select" style="width: auto;">
                                <option value="code">Code</option>
                                <option value="name">Name</option>
                                <option value="group.name">Department</option>
                            </select>
               
                            <!-- Conditional filter field -->
<input
    v-if="filterKey !== 'group.name'"
    type="text"
    v-model="filterText"
    placeholder="Search..."
    class="form-control"
    style="width: 200px;"
/>

<select
    v-else
    class="form-select"
    v-model="selectedGroupId"
    style="width: 200px;"
>
    <option value="">All Departments</option>
    <option v-for="group in groups" :key="group.id" :value="group.id">
        {{ group.name }}
    </option>
</select>

                            <p>
                                <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                    <i class="bi bi-plus-square me-2"></i> Add Item
                                </a>
                            </p>
                        </div>
                    </div>


                    <Overlay :showOverlay="isLoading" />

                    <div class="tile-body">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Department</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cabinet, index) in filteredItems" :key="cabinet.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ cabinet.code }}</td>
                                        <td>{{ cabinet.name }}</td>
                                        <td>{{ cabinet.group?.name }}</td>
                                        <td>
                                            <div class="btn-group btn-group-sm" role="group"
                                                aria-label="Basic mixed styles example">
                                                <button type="button" class="btn btn-warning"
                                                    @click="openEditModal(cabinet)">
                                                    <i class="bi bi-pencil"></i> Edit
                                                </button>
                                                <button type="button" class="btn btn-danger"
                                                    @click="handleDelete(cabinet.id)">
                                                    <i class="bi bi-trash"></i> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="cabinetModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalLabel">
                            {{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}
                        </h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="hideModal"></button>
                    </div>
                    <form @submit.prevent="handleSubmit">
                        <div class="modal-body">
                            <!-- Download QR code button -->
                            <div v-if="modalMode != 'add'" class="text-center">
                                <button type="button" @click="downloadQRCode" class="btn btn-success">Download QR
                                    Code</button>
                            </div>

                            <!-- QRCode generation -->
                            <div v-if="editingItem.code" ref="qrCodeContainer" class="text-center p-4">
                                <div class="text-center mb-3">
                                    <qrcode-vue :value="`${url}/${editingItem.code}`" size="128"></qrcode-vue>
                                </div>
                                <p class="mb-0">
                                    {{ editingItem.name }} [{{ editingItem.code }}]
                                </p>
                                <p class="mb-0">
                                    {{ editingItem.group?.name }}
                                </p>
                                <!-- <p v-clipboard:copy="`${url}/${editingItem.code}`">{{ url
                                    }}/{{ editingItem.code }}</p> -->
                            </div>

                            <div class="mb-3">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" id="name" class="form-control" v-model="editingItem.name" required />
                            </div>

                            <div class="mb-3">
                                <label for="group" class="form-label">Department</label>
                                <select id="group" class="form-select" v-model="editingItem.group_id" required>
                                    <option value="" disabled>- Select -</option>
                                    <option v-for="dept in groups" :key="dept.id" :value="dept.id">
                                        {{ dept.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="hideModal">Close</button>
                            <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                                <span v-if="isSubmitting">
                                    <span class="spinner-border spinner-border-sm me-1" role="status"
                                        aria-hidden="true"></span>
                                    Saving...
                                </span>
                                <span v-else>Save changes</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import { showConfirm, showCreateAlert, showDeleteAlert, showErrorAlert, showUpdateAlert } from '@/utils/sweetalert2-utils';
import Overlay from '@/components/Overlay.vue';
import { Modal } from 'bootstrap';
import QrcodeVue from 'qrcode.vue'
import html2canvas from 'html2canvas';
import AppTitle from '@/layouts/AppTitle.vue';

const qrCodeContainer = ref(null);

const cabinets = ref([]);
const url = ref(`${process.env.VUE_APP_URL_BASE}/view-medicine-cabinet`);
const modalMode = ref('add');
const editingItem = ref({ id: null, code: '', name: '', group_id: '' });
const groups = ref([]);

// const fetchData = async () => {
//     try {
//         const response = await axiosInstance.get('/medicine_cabinet');
//         cabinets.value = response.data;
//     } catch (error) {
//         showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
//     }
// };

const filterKey = ref('code');
const filterText = ref('');

import { computed } from 'vue';
const selectedGroupId = ref('');

const filteredItems = computed(() => {
    return cabinets.value.filter(item => {
        if (filterKey.value === 'group.name') {
            return selectedGroupId.value
                ? item.group_id === selectedGroupId.value
                : true;
        } else {
            const value = item[filterKey.value] || '';
            return value.toLowerCase().includes(filterText.value.toLowerCase());
        }
    });
});

const isLoading = ref(true);

const fetchData = async () => {
    isLoading.value = true;

    try {
        const [Cabinets, groupsRes] = await Promise.all([
            axiosInstance.get('/medicine_cabinet'),
            axiosInstance.get('/group'),
        ]);

        cabinets.value = Cabinets.data;
        groups.value = groupsRes.data;
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    } finally {
        isLoading.value = false;
    }
};

const openAddModal = () => {
    modalMode.value = 'add';
    editingItem.value = { id: null, code: '', name: 'ตู้แช่ยา', group_id: '' };
    showModal();
};

const openEditModal = (cabinet) => {
    modalMode.value = 'edit';
    editingItem.value = { ...cabinet };
    showModal();
};

const isSubmitting = ref(false);

const handleSubmit = async () => {
    isSubmitting.value = true;

    try {
        if (modalMode.value === 'add') {
            await axiosInstance.post('/medicine_cabinet', editingItem.value);
            showCreateAlert();
        } else {
            await axiosInstance.put(`/medicine_cabinet/${editingItem.value.id}`, editingItem.value);
            showUpdateAlert();
        }
        hideModal();
        fetchData();
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกรายการ');
    } finally {
        isSubmitting.value = false;
    }
};

const handleDelete = async (id) => {
    const result = await showConfirm();
    if (result.isConfirmed) {
        try {
            await axiosInstance.delete(`/medicine_cabinet/${id}`);
            cabinets.value = cabinets.value.filter(cabinet => cabinet.id !== id);
            showDeleteAlert();
        } catch (error) {
            showErrorAlert('เกิดข้อผิดพลาดในการลบรายการ');
        }
    }
};

const showModal = () => {
    const modal = new Modal(document.getElementById('cabinetModal'));
    modal.show();
};

const hideModal = () => {
    const modalElement = document.getElementById('cabinetModal');
    const modal = Modal.getInstance(modalElement);
    modal.hide();
};
const downloadQRCode = () => {
    const qrCodeElement = qrCodeContainer.value; // Access the qrCodeContainer ref
    if (qrCodeElement) {
        // Use html2canvas to capture the QR code as a canvas
        html2canvas(qrCodeElement).then((canvas) => {
            const imageUrl = canvas.toDataURL('image/png'); // Convert canvas to PNG image URL
            const link = document.createElement('a'); // Create a temporary link element
            link.href = imageUrl; // Set the download URL
            link.download = `${editingItem.value.code}_qr_code.png`; // Set the default download file name
            link.click(); // Trigger the download
        });
    }
};

onMounted(() => {
    fetchData();
});
</script>